import React from "react";
import "./HomeHeader.css";
import Button from '../Button/Button'
import Slider from '../Slider/Slider'
import Aux from '../../hoc/Aux'
import { Link } from "react-scroll";
import Data from '../../data/Data'

const HomeHeader = () => {
  return (
      <div className='home-header' id="home">
          <div
            className='home-header-row'
          >
            <div className='home-header-col'>
              <div className='home-header-text-wrapper'>
                <div className='home-header-top-line'>welcome to</div>
                <h1 className='home-header-heading'>{Data.companyName}</h1>
                <p className='home-header-subtitle'>
                  {Data.companyDescription}
                </p>
                <Link
                offset={-50}
                spy={true}
                smooth={true} 
                duration={1000}
                to="services">
                  <Button buttonStyle="btn-primary" buttonSize="btn-large">SEE OUR SERVICES</Button>
                </Link>
              </div>
            </div>

            <div className='home-header-col'>
              <div className='home-header-img-wrapper'>
                <img src={Data.companyImage} alt={'image'} className='home-header-img' />
              </div>
            </div>
          </div>
      </div>
  )
};

export default HomeHeader;
